import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { FlexRow } from 'src/components/Reusable/Flex'

export const DiffGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 96px 96px 96px;
  column-gap: 16px;
  align-items: center;
`

export const DiffHeader = styled.span`
  padding: 6px 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${palette.neutral[500]};
  border-bottom: 1px solid ${palette.neutral[100]};

  &:not(:first-child) {
    text-align: right;
  }
`

export const DiffEntityLabel = styled.span`
  padding: 8px 0;
  font-size: 13px;
  color: ${palette.neutral[700]};
  border-bottom: 1px solid ${palette.neutral[50]};
`

export const DiffCount = styled.span`
  padding: 8px 0;
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 13px;
  font-weight: 500;
  color: ${palette.neutral[700]};
  border-bottom: 1px solid ${palette.neutral[50]};
`

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: ${palette.neutral[700]};
`

export const VersionPreview = styled.span`
  font-size: 13px;
  color: ${palette.neutral[600]};
`

export const NumberInput = styled.input`
  width: 80px;
  padding: 6px 10px;
  border: 1px solid ${palette.neutral[300]};
  border-radius: 4px;
  font-size: 14px;
`

export const VersionInputRow = styled(FlexRow)`
  gap: 12px;
`
